import React  from 'react';
import { connect } from "react-redux";
import { DownCaretIcon } from "../icons";
import { addFilterAndApply } from "../../core/actions/filtering";
import { checkActiveFilterMembership, formatValueFromMapping } from "../../utils/misc";


const FiltersList = ({ filterableFields, filterableOptions, availableOptions}) => (
    <div id="filters-list" className="wrapper u-bb-thin ">
        <form action="" method="GET" className="form-label form-css-label u-flex-1">
            <ul className="list-inline tab-nav select-list u-mb--xsmall u-list-reset">
                { filterableFields.map((field) => (
                    <FiltersListItem
                        key={ field.name }
                        field={ field }
                        options={ filterableOptions[field.name] }
                        availableOptions={ availableOptions[field.name] }
                    />
                ))}
            </ul>
        </form>
    </div>
);


const mapStateToProps = (state) => ({
    filterableFields: state.immutableFiltering.fields,
    filterableOptions: state.immutableFiltering.options,
    availableOptions: state.mutableFiltering.availableOptions,
});

export default connect(mapStateToProps)(FiltersList);


const FiltersListItem = ({ field, options, availableOptions }) => (
    <li className="tab-nav__item list-inline__item u-pl-0">
        <FilterSelect { ...field } options={ options } availableOptions={ availableOptions } />
    </li>
);

const _FilterSelect = ({ dispatch, name, display_name, options, activeFilters, valueMapping }) => {

    const defaultValue = `${name}-default`;

    return (
        <fieldset className="fieldset">
            <div className="select-style">
                <select
                    className="cursor-pointer"
                    name={ name }
                    value={ defaultValue }
                    onChange={ (e) => dispatch( addFilterAndApply(name, e.target.value) ) }
                >
                    <option value={ defaultValue } disabled>{ display_name.toString().toUpperCase() }</option>
                    <option value={ null } disabled>-----</option>
                    { options.map((option) => {
                        return (
                            <option
                                key={ option }
                                value={ option }
                                disabled={ checkActiveFilterMembership(activeFilters, name, option) }
                            >
                                { formatValueFromMapping(option, name, valueMapping) }
                            </option>
                        )
                    })}
                </select>
                <DownCaretIcon />
            </div>
        </fieldset>
    )
};

const FilterSelect = connect((state) => ({
    valueMapping: state.immutableBaseData.valueFormatterMapping,
    activeFilters: state.mutableFiltering.activeFilters,
}))(_FilterSelect);

